import { StateCreator } from 'zustand'
import { ResultsType, SimulationStore, Task, WorkflowType } from '../../@types/store'

const createSimulationSlice: StateCreator<
  SimulationStore,
  [["zustand/devtools", never]],
  [],
  SimulationStore
> = (set) => ({
  globalActiveKey: "input",
  processing: false,
  inputActiveKey: "",
  inputTables: {},
  resultsTables: [],
  tasks: [],
  resultsActiveKey: "",
  loadingDetail: false,
  workflow: {
    id: 0,
    num_pages: 0,
    workflow: {
      nodes: [],
      edges: []
    }
  },
  setGlobalActiveKey: (key: string) => set(() => ({ globalActiveKey: key }), false, 'setGlobalActiveKey'),
  setProcessing: (value: boolean) => set(() => ({ processing: value }), false, 'setProcessing'),
  setInputActiveKey: (key: string) => set(() => ({ inputActiveKey: key }), false, 'setInputActiveKey'),
  setInputTables: (data: { [key: string]: any[] }) => set(() => ({ inputTables: data }), false, 'setInputTables'),
  setResultsTables: (data: ResultsType[]) => set(() => ({ resultsTables: data }), false, 'setResultsTables'),
  setResultsActiveKey: (key: string) => set(() => ({ resultsActiveKey: key }), false, 'setResultsActiveKey'),
  setLoadingDetail: (value: boolean) => set(() => ({ loadingDetail: value }), false, 'setLoadingDetail'),
  setWorkflow: (workflow: WorkflowType) => set(() => ({ workflow: workflow }), false, 'setWorkflow'),
  setTask: (task: Task) => set((state) => ({ tasks: [...state.tasks, task] }), false, 'setTask'),
  updateTask: (task: Task, id: string) => set((state) => ({
    tasks:
      state.tasks.map((t) =>
        t.id === id ? { ...t, message: task.message, status: task.status } : t
      ),
  }), false, 'updateTask'),
  resetTasks: () => set(() => ({ tasks: [] }))
})

export default createSimulationSlice
